/* Ardor Canvas Print Builder: print template download (Ardor-branded PDF, guides on a layer) and the "Template" rail button.
   New Oct 12, 2026. Loaded by sections/ardor-canvas-builder-ws-v2.liquid after ardor-canvas-builder-v2.js. Ardor Printing. */
(function () {
  'use strict';
  if (window.ArdorCanvasTemplate) return;
  // ---------- template PDF writer (Ardor Printing, Oct 12 2026) ----------
  // Writes a small vector PDF in the browser: one page per side, page = the print template at its exact size,
  // every guide, label and note on one optional-content layer (OCG) that customers can hide before saving.
  var LAYER = 'Ardor guides - hide before saving';
  function latin1(s) { var b = new Uint8Array(s.length); for (var i = 0; i < s.length; i++) b[i] = s.charCodeAt(i) & 255; return b; }
  function concat(chunks) { var n = 0; chunks.forEach(function (c) { n += c.length; }); var o = new Uint8Array(n), p = 0; chunks.forEach(function (c) { o.set(c, p); p += c.length; }); return o; }
  function num(n) { if (!isFinite(n)) n = 0; var r = Math.round(n * 1000) / 1000; return (Math.abs(r) < 1e-9 ? 0 : r).toString(); }
  var WIN = { 0x2022: 0x95, 0x2013: 0x96, 0x2014: 0x97, 0x2018: 0x91, 0x2019: 0x92, 0x201C: 0x93, 0x201D: 0x94, 0x2026: 0x85, 0xD7: 0xD7 };
  function pdfStr(s) {
    var out = '';
    for (var i = 0; i < s.length; i++) {
      var c = s.charCodeAt(i), b;
      if (c < 128) b = c; else if (c >= 0xA0 && c <= 0xFF) b = c; else if (WIN[c]) b = WIN[c]; else b = 63;
      var ch = String.fromCharCode(b);
      if (ch === '(' || ch === ')' || ch === '\\') ch = '\\' + ch;
      out += ch;
    }
    return '(' + out + ')';
  }
  // Helvetica and Helvetica-Bold widths (1/1000 em) for ASCII 32-126
  var HW = [278,278,355,556,556,889,667,191,333,333,389,584,278,333,278,278,556,556,556,556,556,556,556,556,556,556,278,278,584,584,584,556,1015,667,667,722,722,667,611,778,722,278,500,667,556,833,722,778,667,778,722,667,611,722,667,944,667,667,611,278,278,278,469,556,333,556,556,500,556,556,278,556,556,222,222,500,222,833,556,556,556,556,333,500,278,556,500,722,500,500,500,334,260,334,584];
  var HBW = [278,333,474,556,556,889,722,238,333,333,389,584,278,333,278,278,556,556,556,556,556,556,556,556,556,556,333,333,584,584,584,611,975,722,722,722,722,667,611,778,722,278,556,722,611,833,722,778,667,778,722,667,611,722,667,944,667,667,611,333,278,333,584,556,333,556,611,556,611,556,333,611,611,278,278,556,278,889,611,611,611,611,389,556,333,611,556,778,556,556,500,389,280,389,584];
  function textW(s, size, bold) { var t = bold ? HBW : HW, w = 0; for (var i = 0; i < s.length; i++) { var c = s.charCodeAt(i); w += (c >= 32 && c < 127) ? t[c - 32] : (c === 0xD7 ? 584 : 556); } return w * size / 1000; }
  function wrapText(s, size, bold, maxW) {
    var words = String(s).split(/\s+/), lines = [], cur = '';
    words.forEach(function (w) { var t = cur ? cur + ' ' + w : w; if (textW(t, size, bold) <= maxW || !cur) cur = t; else { lines.push(cur); cur = w; } });
    if (cur) lines.push(cur);
    return lines;
  }
  function deflate(bytes) {
    if (typeof CompressionStream === 'undefined') return Promise.resolve(null);
    var cs = new CompressionStream('deflate'), w = cs.writable.getWriter(); w.write(bytes); w.close();
    return new Response(cs.readable).arrayBuffer().then(function (ab) { return new Uint8Array(ab); });
  }
  function rgb(hex) {
    var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || '#000000') || [0, '00', '00', '00'];
    return num(parseInt(m[1], 16) / 255) + ' ' + num(parseInt(m[2], 16) / 255) + ' ' + num(parseInt(m[3], 16) / 255);
  }

  // A drawing surface in inches, origin at the top-left corner of the page. k = points per inch (7.2 at 1/10 scale).
  function Surface(wIn, hIn, k) { this.k = k; this.wIn = wIn; this.hIn = hIn; this.ops = []; this.alphas = {}; this.images = {}; }
  Surface.prototype.X = function (x) { return num(x * this.k); };
  Surface.prototype.Y = function (y) { return num((this.hIn - y) * this.k); };
  Surface.prototype.gs = function (a) {
    if (a == null || a >= 1) return '';
    var key = 'A' + Math.round(a * 100); this.alphas[key] = Math.round(a * 100) / 100; return '/' + key + ' gs ';
  };
  // o: fill, stroke (hex), alpha (fill), salpha (stroke), lw (inches), dash [on, off] (inches)
  Surface.prototype.paint = function (path, o) {
    var k = this.k, s = 'q ';
    var fa = o.fill ? (o.alpha == null ? 1 : o.alpha) : 1, sa = o.stroke ? (o.salpha == null ? 1 : o.salpha) : 1;
    var a = Math.min(fa, sa); if (a < 1) { var key = 'A' + Math.round(fa * 100) + 'S' + Math.round(sa * 100); this.alphas[key] = [Math.round(fa * 100) / 100, Math.round(sa * 100) / 100]; s += '/' + key + ' gs '; }
    if (o.fill) s += rgb(o.fill) + ' rg ';
    if (o.stroke) {
      s += rgb(o.stroke) + ' RG ' + num((o.lw || 0.02) * k) + ' w ';
      s += o.dash ? '[' + num(o.dash[0] * k) + ' ' + num(o.dash[1] * k) + '] 0 d ' : '[] 0 d ';
      if (o.cap) s += o.cap + ' J ';
    }
    s += path + (o.fill && o.stroke ? (o.evenodd ? ' B*' : ' B') : (o.fill ? (o.evenodd ? ' f*' : ' f') : ' S')) + ' Q';
    this.ops.push(s);
  };
  Surface.prototype.rectPath = function (x, y, w, h) { return this.X(x) + ' ' + this.Y(y + h) + ' ' + num(w * this.k) + ' ' + num(h * this.k) + ' re'; };
  Surface.prototype.rect = function (x, y, w, h, o) { if (w > 0 && h > 0) this.paint(this.rectPath(x, y, w, h), o); };
  // a band around a rectangle: the outer rect minus the inner one
  Surface.prototype.ring = function (outer, inner, o) { var p = this.rectPath(outer[0], outer[1], outer[2], outer[3]) + ' ' + this.rectPath(inner[0], inner[1], inner[2], inner[3]); o.evenodd = true; this.paint(p, o); };
  Surface.prototype.line = function (pts, o, close) {
    var self = this, p = pts.map(function (q, i) { return self.X(q[0]) + ' ' + self.Y(q[1]) + (i ? ' l' : ' m'); }).join(' ');
    this.paint(p + (close ? ' h' : ''), o);
  };
  Surface.prototype.circle = function (cx, cy, r, o) {
    var c = 0.5523 * r, self = this;
    var P = function (x, y) { return self.X(x) + ' ' + self.Y(y); };
    var p = P(cx + r, cy) + ' m ' + P(cx + r, cy - c) + ' ' + P(cx + c, cy - r) + ' ' + P(cx, cy - r) + ' c ' + P(cx - c, cy - r) + ' ' + P(cx - r, cy - c) + ' ' + P(cx - r, cy) + ' c ' +
      P(cx - r, cy + c) + ' ' + P(cx - c, cy + r) + ' ' + P(cx, cy + r) + ' c ' + P(cx + c, cy + r) + ' ' + P(cx + r, cy + c) + ' ' + P(cx + r, cy) + ' c h';
    this.paint(p, o);
  };
  // arc in page inches, angles in radians measured like a canvas (clockwise on screen from +x)
  Surface.prototype.arc = function (cx, cy, r, a0, a1, o) {
    var pts = [], n = 14; for (var i = 0; i <= n; i++) { var t = a0 + (a1 - a0) * i / n; pts.push([cx + r * Math.cos(t), cy + r * Math.sin(t)]); }
    this.line(pts, o);
  };
  // text: size in inches; align left|center|right around x; y is the vertical middle of capital letters; rot 0, 90 (reads upward) or -90
  Surface.prototype.text = function (s, x, y, o) {
    s = String(s); if (!s) return;
    var size = o.size, bold = !!o.bold, w = textW(s, size, bold), rot = o.rot || 0;
    var th = rot * Math.PI / 180, dx = Math.cos(th), dy = Math.sin(th); // direction in PDF space (y up)
    var al = o.align === 'left' ? 0 : (o.align === 'right' ? 1 : 0.5);
    if (o.bg) {
      var pad = size * 0.35, bw = w + pad * 2, bh = size * 1.25;
      if (rot === 90 || rot === -90) this.rect(x - bh / 2, y - bw / 2, bh, bw, { fill: o.bg, alpha: o.bgAlpha == null ? 0.88 : o.bgAlpha }); // rotated labels are always centered
      else this.rect(x - al * w - pad, y - bh / 2, bw, bh, { fill: o.bg, alpha: o.bgAlpha == null ? 0.88 : o.bgAlpha });
    }
    // PDF point of the text center, then back along the baseline and down to the baseline
    var px = x * this.k, py = (this.hIn - y) * this.k, sz = size * this.k, wp = w * this.k;
    var bx = px - al * wp * dx + 0.35 * sz * dy, by = py - al * wp * dy - 0.35 * sz * dx;
    var tm = num(dx) + ' ' + num(dy) + ' ' + num(-dy) + ' ' + num(dx) + ' ' + num(bx) + ' ' + num(by);
    this.ops.push('q ' + (o.alpha != null && o.alpha < 1 ? this.gs(o.alpha) : '') + rgb(o.color || '#0C0D0D') + ' rg BT /' + (bold ? 'FB' : 'FR') + ' ' + num(sz) + ' Tf ' + tm + ' Tm ' + pdfStr(s) + ' Tj ET Q');
    return w;
  };
  Surface.prototype.image = function (name, x, y, w, h) {
    this.images[name] = true;
    this.ops.push('q ' + num(w * this.k) + ' 0 0 ' + num(h * this.k) + ' ' + this.X(x) + ' ' + this.Y(y + h) + ' cm /' + name + ' Do Q');
  };

  // RGBA pixels -> Flate RGB image with a soft mask (alpha) when needed
  function imageObjs(doc, img) {
    var w = img.w, h = img.h, d = img.data, rgbB = new Uint8Array(w * h * 3), al = new Uint8Array(w * h), hasA = false;
    for (var i = 0, j = 0, q = 0; i < d.length; i += 4) { rgbB[j++] = d[i]; rgbB[j++] = d[i + 1]; rgbB[j++] = d[i + 2]; al[q++] = d[i + 3]; if (d[i + 3] !== 255) hasA = true; }
    return Promise.all([deflate(rgbB), hasA ? deflate(al) : Promise.resolve(null)]).then(function (z) {
      if (!z[0]) return null;
      var sm = '';
      if (hasA && z[1]) { var mid = doc.add('<< /Type /XObject /Subtype /Image /Width ' + w + ' /Height ' + h + ' /ColorSpace /DeviceGray /BitsPerComponent 8 /Filter /FlateDecode >>', z[1]); sm = ' /SMask ' + mid + ' 0 R'; }
      return doc.add('<< /Type /XObject /Subtype /Image /Width ' + w + ' /Height ' + h + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /FlateDecode' + sm + ' >>', z[0]);
    });
  }

  function Doc() { this.objs = [null]; }
  Doc.prototype.alloc = function () { this.objs.push(null); return this.objs.length - 1; };
  Doc.prototype.set = function (id, dict, stream) { this.objs[id] = { dict: dict, stream: stream || null }; return id; };
  Doc.prototype.add = function (dict, stream) { return this.set(this.alloc(), dict, stream); };
  Doc.prototype.bytes = function (rootId, infoId) {
    var chunks = [], off = 0, offsets = [0];
    var push = function (b) { chunks.push(b); off += b.length; };
    push(latin1('%PDF-1.6\n%\xE2\xE3\xCF\xD3\n'));
    for (var i = 1; i < this.objs.length; i++) {
      var o = this.objs[i] || { dict: 'null' };
      offsets[i] = off;
      if (o.stream) { push(latin1(i + ' 0 obj\n' + o.dict.replace(/\s*>>\s*$/, '') + ' /Length ' + o.stream.length + ' >>\nstream\n')); push(o.stream); push(latin1('\nendstream\nendobj\n')); }
      else push(latin1(i + ' 0 obj\n' + o.dict + '\nendobj\n'));
    }
    var xref = off, n = this.objs.length, x = 'xref\n0 ' + n + '\n0000000000 65535 f \n';
    for (var j = 1; j < n; j++) x += String(offsets[j]).padStart(10, '0') + ' 00000 n \n';
    x += 'trailer\n<< /Size ' + n + ' /Root ' + rootId + ' 0 R /Info ' + infoId + ' 0 R >>\nstartxref\n' + xref + '\n%%EOF\n';
    push(latin1(x));
    return concat(chunks);
  };

  // pages: [{ wIn, hIn, scale (1 or 0.1), trim: [x, y, w, h] inches or null, draw: function (surface) }]
  // meta: { title, subject, logo: { w, h, data } or null }
  function buildPdf(pages, meta) {
    var doc = new Doc(), enc = new TextEncoder();
    var ocg = doc.add('<< /Type /OCG /Name ' + pdfStr(LAYER) + ' /Usage << /CreatorInfo << /Creator (Ardor Printing) /Subtype /Artwork >> >> >>');
    var fR = doc.add('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>');
    var fB = doc.add('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>');
    var logoP = meta.logo ? imageObjs(doc, meta.logo) : Promise.resolve(null);
    return logoP.then(function (logoId) {
      var pagesId = doc.alloc(), kids = [];
      pages.forEach(function (pg) {
        var k = 72 * (pg.scale || 1), S = new Surface(pg.wIn, pg.hIn, k);
        S.logo = logoId ? meta.logo : null;
        pg.draw(S);
        var body = '/OC /ArdorGuides BDC\n' + S.ops.join('\n') + '\nEMC\n';
        var cid = doc.add('<< >>', enc.encode(body));
        var gsd = Object.keys(S.alphas).map(function (key) { var v = S.alphas[key], fa = Array.isArray(v) ? v[0] : v, sa = Array.isArray(v) ? v[1] : v; return '/' + key + ' << /Type /ExtGState /ca ' + num(fa) + ' /CA ' + num(sa) + ' >>'; }).join(' ');
        var xo = logoId && S.images.Logo ? '/XObject << /Logo ' + logoId + ' 0 R >> ' : '';
        var res = '<< /ProcSet [/PDF /Text /ImageC] /Font << /FR ' + fR + ' 0 R /FB ' + fB + ' 0 R >> ' + xo + (gsd ? '/ExtGState << ' + gsd + ' >> ' : '') + '/Properties << /ArdorGuides ' + ocg + ' 0 R >> >>';
        var PW = num(pg.wIn * k), PH = num(pg.hIn * k), box = '[0 0 ' + PW + ' ' + PH + ']';
        var trim = pg.trim ? '[' + num(pg.trim[0] * k) + ' ' + num((pg.hIn - pg.trim[1] - pg.trim[3]) * k) + ' ' + num((pg.trim[0] + pg.trim[2]) * k) + ' ' + num((pg.hIn - pg.trim[1]) * k) + ']' : box;
        kids.push(doc.add('<< /Type /Page /Parent ' + pagesId + ' 0 R /MediaBox ' + box + ' /BleedBox ' + box + ' /TrimBox ' + trim + (pg.scale && pg.scale !== 1 ? ' /UserUnit ' + num(1 / pg.scale) : '') + ' /Resources ' + res + ' /Contents ' + cid + ' 0 R >>'));
      });
      doc.set(pagesId, '<< /Type /Pages /Kids [' + kids.map(function (id) { return id + ' 0 R'; }).join(' ') + '] /Count ' + kids.length + ' >>');
      var root = doc.add('<< /Type /Catalog /Pages ' + pagesId + ' 0 R /PageMode /UseOC /OCProperties << /OCGs [' + ocg + ' 0 R] /D << /Name (Ardor template) /Order [' + ocg + ' 0 R] /ON [' + ocg + ' 0 R] /OFF [] >> >> >>');
      var d = new Date(), pad = function (n) { return String(n).padStart(2, '0'); };
      var ds = 'D:' + d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) + pad(d.getHours()) + pad(d.getMinutes()) + pad(d.getSeconds());
      var info = doc.add('<< /Title ' + pdfStr(meta.title || 'Ardor Printing template') + ' /Subject ' + pdfStr(meta.subject || '') + ' /Author (Ardor Printing) /Creator (ardorprinting.com) /Producer (Ardor Printing) /CreationDate (' + ds + ') >>');
      return doc.bytes(root, info);
    });
  }

  // ---------- shared drawing: the note block with the logo, centered in a box (inches) ----------
  // lines: [{ t, bold, size (x T), color }]; box: [x, y, w, h]; T: base text size in inches
  function noteBlock(S, box, T, lines) {
    var maxW = box[2] * 0.92, rows = [];
    lines.forEach(function (L) { var sz = T * (L.size || 1); wrapText(L.t, sz, L.bold, maxW).forEach(function (r) { rows.push({ t: r, sz: sz, bold: L.bold, color: L.color }); }); });
    var gap = 0.42, logoH = S.logo ? T * 2.4 : 0, h = logoH + (logoH ? T * 0.9 : 0) + T * 1.0;
    rows.forEach(function (r) { h += r.sz * (1 + gap); });
    var wMax = 0; rows.forEach(function (r) { wMax = Math.max(wMax, textW(r.t, r.sz, r.bold)); });
    var logoW = S.logo ? logoH * S.logo.w / S.logo.h : 0, site = 'ardorprinting.com', siteW = textW(site, T * 0.95, true);
    wMax = Math.max(wMax, logoW, siteW);
    var bw = Math.min(box[2], wMax + T * 2), bh = h + T * 1.6, bx = box[0] + (box[2] - bw) / 2, by = box[1] + (box[3] - bh) / 2;
    S.rect(bx, by, bw, bh, { fill: '#FFFFFF', alpha: 0.9, stroke: '#DCDDE0', lw: T * 0.05 });
    var y = by + T * 0.9, cx = bx + bw / 2;
    if (S.logo) { S.image('Logo', cx - logoW / 2, y, logoW, logoH); y += logoH + T * 0.55; }
    S.text(site, cx, y + T * 0.45, { size: T * 0.95, bold: true, color: '#BD252C' }); y += T * 1.0 + T * 0.55;
    rows.forEach(function (r) { y += r.sz * (0.5 + gap / 2); S.text(r.t, cx, y, { size: r.sz, bold: r.bold, color: r.color || '#0C0D0D' }); y += r.sz * (0.5 + gap / 2); });
    return [bx, by, bw, bh];
  }
  // base text size: about 12 px when the page is zoomed to fit a 1000 x 700 px window, within limits
  function baseSize(TW, TH, safe) {
    var T = Math.max(TW / 83, TH / 58, 0.12);
    if (safe) T = Math.min(T, safe[3] / 15, safe[2] / 24);
    return Math.max(T, Math.min(TW, TH) / 400);
  }
  function fmtIn(n) { var r = Math.round(n * 100) / 100; return Math.abs(r - Math.round(r)) < 0.001 ? String(Math.round(r)) : String(r); }

  // ---------- logo: the theme's logo PNG as RGBA pixels (null if it cannot be read) ----------
  var logoP = null;
  function loadLogo(url) {
    if (logoP) return logoP;
    logoP = !url ? Promise.resolve(null) : fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('logo'); return r.blob(); }).then(function (bl) {
      return new Promise(function (res) {
        var im = new Image(), u = URL.createObjectURL(bl);
        im.onload = function () {
          var s = Math.min(1, 640 / Math.max(im.naturalWidth || 1, im.naturalHeight || 1)), w = Math.max(1, Math.round(im.naturalWidth * s)), h = Math.max(1, Math.round(im.naturalHeight * s));
          var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
          var cx = cv.getContext('2d'); cx.drawImage(im, 0, 0, w, h);
          var data; try { data = cx.getImageData(0, 0, w, h).data; } catch (e) { data = null; }
          URL.revokeObjectURL(u); res(data ? { w: w, h: h, data: data } : null);
        };
        im.onerror = function () { URL.revokeObjectURL(u); res(null); };
        im.src = u;
      });
    }).catch(function () { return null; });
    return logoP;
  }

  // ---------- the "Template" rail button and the line in the Artwork panel ----------
  var ICON = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 8V5.5A1.5 1.5 0 0 1 5.5 4H8M16 4h2.5A1.5 1.5 0 0 1 20 5.5V8M20 16v2.5a1.5 1.5 0 0 1-1.5 1.5H16M8 20H5.5A1.5 1.5 0 0 1 4 18.5V16"/><path d="M12 7.5v8.5m0 0 3.3-3.3M12 16l-3.3-3.3"/></svg>';
  var CSS = '.abt-line{margin:10px 0 0;font-size:13px;line-height:1.45;color:#6B6F76}' +
    '.abt-link{appearance:none;-webkit-appearance:none;background:none;border:0;padding:0;margin:0;font:inherit;font-weight:600;color:#0C0D0D;text-decoration:underline;text-underline-offset:2px;cursor:pointer;text-align:left;letter-spacing:0;text-transform:none;min-height:0}' +
    '.abt-link:hover{color:var(--abb-accent,#BD252C)}.abt-link[aria-busy="true"]{opacity:.6;cursor:progress}' +
    '.abx-rail [data-abt-tpl][aria-busy="true"]{opacity:.6;cursor:progress}' +
    '@media (max-width:749px){.abx-rail [data-abt-tpl]{display:none!important}}';
  function saveBlob(blob, name) {
    var url = URL.createObjectURL(blob), a = document.createElement('a');
    a.href = url; a.download = name; a.style.display = 'none';
    document.body.appendChild(a); a.click();
    setTimeout(function () { try { document.body.removeChild(a); URL.revokeObjectURL(url); } catch (e) {} }, 60000);
  }
  function toast(root, msg) {
    var t = root && root.querySelector('[data-abb-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.hidden = true; }, 5000);
  }
  // o: { noun, event, make: function () -> Promise<{ blob, name, data }> }
  function mountUi(o) {
    var root = document.querySelector('[data-abb-root]'); if (!root) return null;
    if (!document.querySelector('style[data-abt]')) { var st = document.createElement('style'); st.setAttribute('data-abt', ''); st.textContent = CSS; document.head.appendChild(st); }
    var busy = false, btns = [];
    var run = function (e, from) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      if (busy) return;
      busy = true; btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      var link = root.querySelector('[data-abt-link]'), old = link ? link.textContent : '';
      if (link) link.textContent = 'Making your template…';
      var fin = function () { busy = false; btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); if (link) link.textContent = old; };
      setTimeout(function () {
        Promise.resolve().then(o.make).then(function (r) {
          saveBlob(r.blob, r.name);
          toast(root, 'Template downloaded: ' + r.name);
          try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: o.event, from: from }, r.data || {})); } catch (er) {}
          fin();
        }).catch(function () { toast(root, 'We couldn\'t make the template. Please try again, or call us at (425) 629-0796.'); fin(); });
      }, 30);
    };
    // the line under the upload help in the Artwork panel
    var drop = root.querySelector('[data-abb-drop]');
    if (drop && !drop.querySelector('[data-abt-line]')) {
      var p = document.createElement('p'); p.className = 'abt-line'; p.setAttribute('data-abt-line', '');
      p.innerHTML = 'Working with a designer? <button type="button" class="abt-link" data-abt-link>Download the template for this size</button>';
      var help = drop.querySelector('.abb-help'), nameEl = drop.querySelector('[data-abb-file-name]');
      if (help && help.parentNode === drop) drop.insertBefore(p, help.nextSibling); else if (nameEl) drop.insertBefore(p, nameEl); else drop.appendChild(p);
      var lb = p.querySelector('[data-abt-link]'); btns.push(lb);
      lb.addEventListener('click', function (e) { run(e, 'panel'); });
    }
    // the rail button, right after the PDF button (added by assets/ardor-proofsheet.js), or after Quote
    var tries = 0;
    (function again() {
      var rail = root.querySelector('.abx-rail');
      if (rail && rail.querySelector('[data-abt-tpl]')) return;
      var pdf = rail && rail.querySelector('[data-abb-pdf]');
      if (!rail || (!pdf && tries < 40)) { if (++tries < 120) setTimeout(again, 150); return; }
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'abx-tool'; b.setAttribute('data-abt-tpl', ''); b.title = 'Download a print template for this ' + o.noun;
      b.innerHTML = ICON + '<span>Template</span>';
      var after = pdf || rail.querySelector('[data-abx-quote]');
      if (after && after.parentNode === rail) rail.insertBefore(b, after.nextSibling); else rail.appendChild(b);
      btns.push(b);
      b.addEventListener('click', function (e) { run(e, 'rail'); });
    })();
    return { run: run };
  }
  // ---------- canvas print template (assets/ardor-canvas-tpl.js) ----------
  // The template is what the builder prints:
  //   Image wrap: the face plus BLEED (1.75 in) on every side: 1.5 in that wraps the sides of the 1.5 in deep frame and
  //   0.25 in that folds to the back. Mirrored, Black and White edge, and the floating frame: the exact face size.
  // Numbers come from the builder (window.ArdorCanvasBuilder.bleed / depth / safe, exposed by ardor-canvas-builder-v2.js).
  function CB() { return window.ArdorCanvasBuilder || null; }
  function k3() { var b = CB() || {}; return { bleed: b.bleed > 0 ? b.bleed : 1.75, depth: b.depth > 0 ? b.depth : 1.5, safe: b.safe > 0 ? b.safe : 0.5 }; }
  var EDGE_SLUG = { wrap: 'Image-wrap', mirror: 'Mirrored-edge', black: 'Black-edge', white: 'White-edge' };

  // v2 (Oct 19, 2026, wall art; copy of ardor-canvas-tpl.js, unchanged): acrylic prints, framed prints and canvas rolls
  // (c.custom / c.printFrame from ardor-canvas-builder-v3.js) get their own titles, file names and notes.
  function wallName(c) { return c.kind === 'acrylic' ? 'acrylic print, ' + (c.acrName || 'Full White Backing') : (c.kind === 'roll' ? 'canvas roll' : 'framed print, wood frame'); }
  function wallSlug(c) { return c.kind === 'acrylic' ? 'Acrylic-Print' : (c.kind === 'roll' ? 'Canvas-Roll' : 'Framed-Print'); }
  function spec(c) {
    var K = k3(), Wi = c.Wi, Hi = c.Hi, wrap = !!c.wrap && !c.framed, b = wrap ? K.bleed : 0;
    var TW = Wi + 2 * b, TH = Hi + 2 * b;
    var faceTxt = fmtIn(Wi) + ' x ' + fmtIn(Hi) + ' in', wall = !!(c.custom || c.printFrame);
    var title = wall ? faceTxt + ' ' + wallName(c) : c.framed ? faceTxt + ' floating frame' + (c.frameName ? ', ' + c.frameName : '') : faceTxt + ' canvas print, ' + (c.edgeName || 'Mirrored edge');
    return {
      c: c, Wi: Wi, Hi: Hi, b: b, TW: TW, TH: TH, wrap: wrap, depth: K.depth, safeIn: K.safe, faceTxt: faceTxt, title: title,
      safe: [b + K.safe, b + K.safe, Wi - 2 * K.safe, Hi - 2 * K.safe], scale: Math.max(TW, TH) > 200 ? 0.1 : 1,
      key: fmtIn(Wi) + 'x' + fmtIn(Hi) + '+' + b + (wall ? wallSlug(c) : (c.framed ? 'F' : c.edge)), wall: wall,
      file: wall ? 'Ardor-Template-' + wallSlug(c) + '-' + fmtIn(Wi) + 'x' + fmtIn(Hi) + 'in.pdf' : c.framed ? 'Ardor-Template-Floating-Frame-' + fmtIn(Wi) + 'x' + fmtIn(Hi) + 'in.pdf'
        : 'Ardor-Template-Canvas-' + fmtIn(Wi) + 'x' + fmtIn(Hi) + 'in-' + (EDGE_SLUG[c.edge] || 'Mirrored-edge') + '.pdf'
    };
  }

  function drawPage(S, s) {
    var c = s.c, b = s.b, Wi = s.Wi, Hi = s.Hi, TW = s.TW, TH = s.TH;
    var T = baseSize(TW, TH, s.safe), L = Math.max(T * 0.06, Math.min(TW, TH) / 2000);
    var lb = { bold: true, color: '#0C0D0D', bg: '#FFFFFF', bgAlpha: 0.85 };
    if (s.wrap) {
      var back = b - s.depth; // the part that folds to the back
      S.ring([0, 0, TW, TH], [back, back, TW - 2 * back, TH - 2 * back], { fill: '#BD252C', alpha: 0.13 });
      S.ring([back, back, TW - 2 * back, TH - 2 * back], [b, b, Wi, Hi], { fill: '#0C0D0D', alpha: 0.10 });
      // corners fold under: a little darker
      [[0, 0], [TW - b, 0], [0, TH - b], [TW - b, TH - b]].forEach(function (p) { S.rect(p[0], p[1], b, b, { fill: '#0C0D0D', alpha: 0.10 }); });
      var thin = { stroke: '#5E5A55', lw: L * 0.8, dash: [T * 0.3, T * 0.2] };
      S.rect(back, back, TW - 2 * back, TH - 2 * back, thin);
      // fold line = the edge of the front
      S.rect(b, b, Wi, Hi, { stroke: '#0C0D0D', lw: L * 1.6, dash: [T * 0.6, T * 0.35] });
      var ss = Math.min(s.depth * 0.3, T * 0.9);
      S.text('TOP SIDE (' + fmtIn(s.depth) + ' in)', TW / 2, back + s.depth / 2, Object.assign({ size: ss }, lb));
      S.text('BOTTOM SIDE (' + fmtIn(s.depth) + ' in)', TW / 2, TH - back - s.depth / 2, Object.assign({ size: ss }, lb));
      S.text('LEFT SIDE (' + fmtIn(s.depth) + ' in)', back + s.depth / 2, TH / 2, Object.assign({ size: ss, rot: 90 }, lb));
      S.text('RIGHT SIDE (' + fmtIn(s.depth) + ' in)', TW - back - s.depth / 2, TH / 2, Object.assign({ size: ss, rot: -90 }, lb));
      var fs = Math.min(back * 0.55, T * 0.7);
      S.text('FOLDS TO THE BACK (' + fmtIn(back) + ' in)', TW / 2, back / 2, { size: fs, bold: true, color: '#8E1B21' });
      S.text('FOLDS TO THE BACK (' + fmtIn(back) + ' in)', TW / 2, TH - back / 2, { size: fs, bold: true, color: '#8E1B21' });
      S.text('FRONT ' + s.faceTxt, b + Wi / 2, b + s.safeIn / 2, { size: Math.min(s.safeIn * 0.55, T * 0.8), bold: true, color: '#0C0D0D' });
    } else {
      if (c.edge === 'mirror' && !c.framed && !s.wall) {
        // the outer 1.5 in of the face is what we mirror onto the sides (it stays on the front too)
        var d = s.depth;
        if (Wi > 2 * d && Hi > 2 * d) S.rect(d, d, Wi - 2 * d, Hi - 2 * d, { stroke: '#5E5A55', lw: L * 0.8, dash: [T * 0.15, T * 0.2] });
        S.text('Outer ' + fmtIn(d) + ' in: mirrored onto the sides', Wi / 2, d - (d - s.safeIn) / 2, { size: Math.min((d - s.safeIn) * 0.5, T * 0.8), color: '#45484D' });
      }
      S.text(c.framed || s.wall ? 'PRINT ' + s.faceTxt : 'FRONT ' + s.faceTxt, Wi / 2, s.safeIn / 2, { size: Math.min(s.safeIn * 0.55, T * 0.8), bold: true, color: '#0C0D0D' });
      S.rect(0, 0, Wi, Hi, { stroke: '#0C0D0D', lw: L * 1.6 });
    }
    S.rect(s.safe[0], s.safe[1], s.safe[2], s.safe[3], { stroke: '#BD252C', lw: L * 1.6, dash: [T * 0.5, T * 0.3] });
    var lines = [{ t: s.title, bold: true, size: 1.3 }];
    if (s.wrap) {
      lines.push({ t: 'Template ' + fmtIn(TW) + ' x ' + fmtIn(TH) + ' in = the ' + s.faceTxt + ' front + ' + fmtIn(s.depth) + ' in sides + ' + fmtIn(b - s.depth) + ' in that folds to the back, on every side.', size: 0.9 });
      lines.push({ t: 'Extend your picture to the outer edge.', bold: true });
      lines.push({ t: 'Keep faces and words inside the dashed red line.', bold: true });
      lines.push({ t: 'Dashed black line: the fold, where the front ends and the sides begin.', size: 0.85, color: '#45484D' });
    } else {
      lines.push({ t: 'Template ' + s.faceTxt + ' = ' + (c.framed || s.wall ? 'your picture at its exact size.' : 'the front of your canvas.'), size: 0.9 });
      lines.push({ t: 'Extend the background to the outer edge.', bold: true });
      lines.push({ t: 'Keep faces and words inside the dashed red line.', bold: true });
      if (s.wall) lines.push({ t: c.kind === 'acrylic' ? 'Printed on the back of 1/4 in clear acrylic (' + (c.acrName || '') + ').' + (c.holes && c.holes.length ? ' Holes are 1.5 in in from the edges: keep words clear of them.' : '') + (c.acr === 'spot' ? ' Save it as a PNG with a transparent background.' : '') : (c.kind === 'roll' ? 'Printed on 15 mil canvas, not stretched, shipped rolled.' : 'Set in a wood frame that covers no part of your picture.'), size: 0.85, color: '#45484D' });
      else if (c.framed) lines.push({ t: 'Mounted flat and set in a ' + String(c.frameName || '').toLowerCase() + ' floating frame, with a narrow gap between the picture and the frame.', size: 0.85, color: '#45484D' });
      else if (c.edge === 'mirror') lines.push({ t: 'Mirrored edge: we make the ' + fmtIn(s.depth) + ' in sides from a mirror image of the outer ' + fmtIn(s.depth) + ' in of your picture. Your whole picture stays on the front.', size: 0.85, color: '#45484D' });
      else lines.push({ t: (c.edge === 'black' ? 'Black' : 'White') + ' edge: the ' + fmtIn(s.depth) + ' in sides are solid ' + (c.edge === 'black' ? 'black' : 'white') + '. Your whole picture stays on the front.', size: 0.85, color: '#45484D' });
    }
    lines.push({ t: 'Before you save your print file, hide or delete the layer "' + LAYER + '".', size: 0.85, color: '#45484D' });
    var sf = s.safe, m = T * 0.6;
    noteBlock(S, [sf[0] + m, sf[1] + m, Math.max(sf[2] - 2 * m, T * 8), Math.max(sf[3] - 2 * m, T * 6)], T, lines);
  }

  // Is this upload a finished template for the current canvas? (page aspect within 1% and, for Image wrap, closer to the
  // template than to the bare face; or a PDF/AI/EPS whose page is the template size)
  function match(c, a) {
    if (!a || !(a.natW > 0 && a.natH > 0)) return null;
    var s = spec(c), ia = a.natW / a.natH, ta = s.TW / s.TH, fa = s.Wi / s.Hi;
    var dT = Math.abs(ia / ta - 1), dF = Math.abs(ia / fa - 1);
    if (dT > 0.01) return null;
    var pts = /^(pdf|ai|eps)$/.test(a.src || '');
    var sizeOk = pts && [72, 7.2].some(function (k) { return Math.abs(a.natW / k / s.TW - 1) <= 0.01 && Math.abs(a.natH / k / s.TH - 1) <= 0.01; });
    if (!(s.b > 0 && dT < dF) && !sizeOk) return null;
    return { w: Math.max(s.TW, s.TH * ia), key: s.key, bleed: s.b };
  }

  function build(c, logo) {
    var s = spec(c);
    var pages = [{ wIn: s.TW, hIn: s.TH, scale: s.scale, trim: null, draw: function (S) { drawPage(S, s); } }];
    return buildPdf(pages, { title: 'Ardor Printing template, ' + s.title, subject: 'Print template from ardorprinting.com', logo: logo || null }).then(function (bytes) {
      return { blob: new Blob([bytes], { type: 'application/pdf' }), name: s.file, spec: s };
    });
  }
  function conf() { try { return JSON.parse(document.querySelector('[data-abb-config]').textContent) || {}; } catch (e) { return {}; } }
  function make() {
    var b0 = CB(); if (!b0 || !b0.cfg) return Promise.reject(new Error('builder'));
    var c = b0.cfg();
    return loadLogo(conf().logoUrl).then(function (logo) { return build(c, logo); }).then(function (r) {
      r.data = { size: c.size && c.size.key, orientation: c.orient, edge: c.edge, style: c.style, kind: c.kind };
      return r;
    });
  }
  window.ArdorCanvasTemplate = { version: 'ardor-canvas-tpl-2', spec: spec, match: match, build: build, make: make, layer: LAYER };
  if (typeof document !== 'undefined' && document.querySelector) {
    var tries = 0;
    (function go() {
      if (CB() && document.querySelector('[data-abb-root]')) { window.ArdorCanvasTemplate.ui = mountUi({ noun: 'canvas print', event: 'ardor_canvas_template_download', make: make }); return; }
      if (++tries < 100) setTimeout(go, 100);
    })();
  }
})();
